import { debug } from 'console';
import * as $ from 'jquery';
import * as _ from 'lodash';


export type ProgressBarOptions = {
    min?: number,
    max?: number,
    now?: number,
    height?: number,
    width?: number,
    prefix?: string,
    showLabel?: boolean,
    showInnerLabel?: boolean,
}

/** */
export class ProgressBar {

    /** */
    public container: JQuery<any>;
    /** */
    public progress: JQuery<any>;
    /** */
    public progressBar: JQuery<HTMLElement>;
    /***/
    public labels: JQuery<any>;
    /** */
    public prefix = '%';
    /** */
    public parRemaining: number;
    /** */
    protected _max = 100;
    /** */
    get max() { return this._max; }
    /** */
    set max(value) {
        this._max = value;
        this.progressBar.prop('aria-valuemax', this.max);
    }

    /** */
    protected _min = 0;
    /** */
    get min() { return this._min; }
    /** */
    set min(value) {
        this._min = value;
        this.progressBar.prop('aria-valuemin', this.min);
    }

    /** */
    protected _height = null;
    /** */
    get height() { return this._height; }
    /** */
    set height(value) {
        this._height = value;
        this.progress.height(this._height);
    }
    /** */
    protected _width = null;
    /** */
    get width() { return this._width; }
    /** */
    set width(value) {
        this._width = value;
        //this.progress.width(this._width);
        //if (this._width) {
        //    this.container.addClass('d-inline-block');
        //} else {
        //    this.container.removeClass('d-inline-block');
        //}
        this.container.width(this._width);
    }

    /** */
    protected _current = 0;
    /** */
    get current() { return this._current; }
    /** */
    set current(value) {
        //this._current = value;
        this.set(value);
    }

    /**/
    protected showLabel: boolean;
    /**/
    protected showInnerLabel: boolean;


    /***/
    public onTickedLabel: (current: number) => string;

    /**
     * 
     * @param selector
     * @param options
     */
    constructor(selector: any, options?: ProgressBarOptions) {
        this.container = $(selector);

        this.showLabel = (!_.isNil(options.showLabel)) ? options.showLabel : true;
        this.showInnerLabel = (!_.isNil(options.showInnerLabel)) ? options.showInnerLabel : true;

        this.create();

        this.max = (!_.isNil(options.max)) ? options.max : this.max;
        this.min = (!_.isNil(options.min)) ? options.min : this.min;
        this.current = (!_.isNil(options.now)) ? options.now : this.current;
        this.height = (!_.isNil(options.height)) ? options.height : this.height;
        this.width = (!_.isNil(options.width)) ? options.width : this.width;

        if (!_.isNil(options.prefix)) {
            this.prefix = options.prefix;
        }

    }

    /** */
    private create() {

        //<div class="progress">
        //    <div class="progress-bar" role="progressbar" style="width: 25%;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">25%</div>
        //</div>

        //自身が.progressの場合、許さない（クラス消す）
        if (this.container.is('.progress')) {
            this.container.removeClass('progress');
        }
        this.container.addClass('sp-progress-container');

        //中身を一旦クリア
        this.container.empty();


        //基本モジュール勝ちで勝手に構造を構築
        this.progress = $('<div>').addClass('progress').addClass('sp-progress');
        this.container.append(this.progress);
        this.progressBar = $('div.progress-bar', this.progress);
        if (this.progressBar.length === 0) {
            this.progressBar = $('<div>').addClass('progress-bar').addClass('sp-progress-bar');
            this.progress.append(this.progressBar);
        }

        if (this.showLabel) {
            //this.labels = $('<span>').addClass('sp-progress-label');
            this.labels = $('<div>').addClass('sp-progress-label');
            //this.progress.append(this.labels);
            //this.container.append(this.labels);
            this.container.prepend(this.labels);
        }
    }

    /**
     * @param n
     */
    protected set(n) {

        this._current = (n > this.max) ? this.max : n;
        this.parRemaining = Math.ceil((this._current / this.max) * 100);
        this.parRemaining = Number.isSafeInteger(this.parRemaining) ? this.parRemaining : null;
        this.progressBar.css('width', this.parRemaining + '%').prop('aria-valuenow', this._current);
        this.setLabel();
        return this;
    }

    /** */
    setLabel() {
        if (this.showInnerLabel) {
            //this.progressBar.text(this._current);
            this.progressBar.text(this.parRemaining + + this.prefix);
        }
        if (this.showLabel) {
            //var text = (this.setLabelFunc) ? this.setLabelFunc(this.current) : this.parRemaining + this.prefix;
            var text = (this.onTickedLabel) ? this.onTickedLabel(this.current) : (!_.isNil(this.parRemaining)) ? this.parRemaining + this.prefix : '';
            this.labels?.text(text);
        }
    }

    /** */
    animate(animate: boolean) {
        if (animate) {
            this.progressBar.addClass('progress-bar-striped progress-bar-animated');
        } else {
            this.progressBar.removeClass('progress-bar-striped progress-bar-animated');
        }
        return this;
    }

};
